/**
 * Configuración derivada de las variables de entorno Vite.
 *
 * Centralizar aquí evita que los componentes lean `import.meta.env` con
 * claves sueltas (fácil de typo-ear). También aplica coerciones y defaults.
 *
 * Al build time, Vite reemplaza cada `import.meta.env.VITE_*` con string
 * literal; si una var no está definida en `.env.local` queda como `undefined`.
 */

function required(value: string | undefined, name: string): string {
  if (!value) {
    throw new Error(
      `[env] ${name} no está definido. Copia .env.example a .env.local y rellena los valores.`,
    );
  }
  return value;
}

const useMocks = import.meta.env.VITE_USE_MOCKS === 'true';

/** Muestra credenciales demo pre-rellenas en la pantalla de login (solo sandbox). */
const showDemoCredentials = import.meta.env.VITE_SHOW_DEMO_CREDENTIALS === 'true';

export const env = {
  /** 'true' → MSW + MockAuthProvider. 'false' → backend real + Cognito real. */
  useMocks,

  /** Muestra el chip de usuarios demo y la contraseña pre-rellena en login (sandbox UI). */
  showDemoCredentials,

  /**
   * Base URL del HTTP API. Ejemplo:
   *   https://s9zgjbq8le.execute-api.us-east-1.amazonaws.com
   * Cuando `useMocks=true` las llamadas igual se interceptan por MSW, así que
   * este valor puede estar vacío en modo mocks.
   */
  apiUrl: useMocks
    ? (import.meta.env.VITE_API_URL ?? '')
    : required(import.meta.env.VITE_API_URL, 'VITE_API_URL'),

  /** Cognito User Pool ID. Solo requerido cuando `useMocks=false`. */
  cognitoUserPoolId: useMocks
    ? (import.meta.env.VITE_COGNITO_USER_POOL_ID ?? '')
    : required(import.meta.env.VITE_COGNITO_USER_POOL_ID, 'VITE_COGNITO_USER_POOL_ID'),

  /** Cognito User Pool Client ID. Solo requerido cuando `useMocks=false`. */
  cognitoClientId: useMocks
    ? (import.meta.env.VITE_COGNITO_CLIENT_ID ?? '')
    : required(import.meta.env.VITE_COGNITO_CLIENT_ID, 'VITE_COGNITO_CLIENT_ID'),

  awsRegion: import.meta.env.VITE_AWS_REGION ?? 'us-east-1',
} as const;
